import { FeatureMainProps } from '../../../../components/Features/FeatureMain/types'

export const pageData: FeatureMainProps = {
    accentColor: '#b08d4a',
    pc: {
        background: '/features/kinokuniya-20260727/pc_bg.jpg',
        // pc_bg は夕景で明るいため、既定の紺(rgba(19,47,84,0.78))だと青浮きする。
        // 彩度を落として暗く沈めるほぼ黒に近い紺を重ねる
        overlay: 'rgba(15, 26, 46, 0.7)',
        eyebrow: '求人特集',
        titleLines: ['紀伊乃国屋'],
        contentsColor: '#1f4a7a',
    },
    hero: {
        image: '/features/kinokuniya-20260727/hero.jpg',
        alt: '紀伊乃国屋',
        analyticsLabel: 'FV',
    },
    headline: {
        title: [
            { text: '人を' },
            { text: '感動', accent: true },
            { text: 'させ、' },
            { text: '人を', breakBefore: true },
            { text: '幸せ', accent: true },
            { text: 'にする' },
        ],
        paragraphs: [
            {
                text: '創業70年を超える老舗ながら、地域の自然と文化を活かした新しいリゾート開発に挑戦中。',
            },
            { text: 'お客さまの特別な時間を', breakBefore: true },
            { text: 'あなたの笑顔で彩りませんか。', breakBefore: true },
        ],
    },
    thumbnail: {
        image: '/features/kinokuniya-20260727/top_sub.jpg',
        alt: '紀伊乃国屋',
    },
    featuresTitle: ['紀伊乃国屋', 'で働く魅力'],
    featuresTitleAnalyticsLabel: 'CT_Charm_働く魅力-タイトル',
    features: [
        {
            heading: ['寮・家賃補助完備。', '絶好のロケーションで新生活を'],
            body: [
                '目の前に広がる穏やかな海と、波の音に癒される絶好のロケーションです。単身用の寮や家賃補助など、手厚い住宅サポートが完備されているため、遠方からの移住でも安心。スムーズに海辺での新生活を始められます。',
            ],
            image: '/features/kinokuniya-20260727/section_01.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-1st',
        },
        {
            heading: ['安定した基盤と、', 'アイデアを活かせる風土'],
            body: [
                '創業70年以上の安定した経営基盤と、年齢や社歴を問わず現場の声を大切にする風通しの良さが特徴です。宿泊プランの提案やサービス改善など、自らのアイデアを形にしながらチームと共に成長できるやりがいがあります。',
            ],
            image: '/features/kinokuniya-20260727/section_02.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-2nd',
        },
        {
            heading: ['小規模だからできる、', '温まるおもてなし'],
            body: [
                'お客さま一人ひとりとじっくり向き合えます。マニュアルに縛られないあなたらしい気配りを活かし、お客さまの喜びをダイレクトに感じながら上質なホスピタリティを磨ける環境です。',
            ],
            image: '/features/kinokuniya-20260727/section_03.jpg',
            analyticsLabel: 'CT_Charm_働く魅力-3rd',
        },
    ],
    floatingCta: {
        label: '求人一覧を見る',
        analyticsLabel: 'CT_Jobinformation_追従CTA',
    },
    jobs: {
        eyebrow: 'pickup',
        title: ['紀伊乃国屋', '求人特集'],
        analyticsLabel: 'CT_Jobinformation_求人特集-タイトル',
        categories: [
            {
                id: 'sazane',
                categoryLabel: 'さざね',
                variant: 'list',
                description:
                    '千葉県安房郡鋸南町、東京湾を望む海岸沿いに佇む高級旅館です。2019年の台風被災を乗り越え、千葉県・鋸南町の復興を象徴する宿でもあります。',
                jobs: [
                    {
                        offerId: '121101',
                        badgeLabel: '料飲部門 | 料飲全般',
                        title: '【未経験歓迎＊社宅・寮あり】鋸南町の復興を象徴する宿でサービススタッフ募集',
                        brandName: '紀伊乃国屋グループ さざね',
                        brandLogo:
                            '/features/kinokuniya-20260727/logo_kinokuniya.png',
                        salary: '350~420',
                        salaryUnit: '年収',
                        prefecture: '千葉県',
                        city: '安房郡鋸南町',
                        image: '/features/kinokuniya-20260727/job_card_sazane_01.jpg',
                        href: 'https://hotel.foods-labo.com/offers/121101',
                        analyticsLabel: 'CT_Jobinformation_求人例-さざね-1st',
                    },
                    {
                        offerId: '121100',
                        badgeLabel: '宿泊部門 | 宿泊全般',
                        title: '《移住サポートあり》南房総の高級旅館×全12室×オーシャンビュー×天然温泉',
                        brandName: '紀伊乃国屋グループ さざね',
                        brandLogo:
                            '/features/kinokuniya-20260727/logo_kinokuniya.png',
                        salary: '350~420',
                        salaryUnit: '年収',
                        prefecture: '千葉県',
                        city: '安房郡鋸南町',
                        image: '/features/kinokuniya-20260727/job_card_sazane_02.jpg',
                        href: 'https://hotel.foods-labo.com/offers/121100',
                        analyticsLabel: 'CT_Jobinformation_求人例-さざね-2nd',
                    },
                ],
            },
            {
                id: 'ippe',
                categoryLabel: 'いっぺ\nTHE SAKE RYOKAN',
                variant: 'list',
                description:
                    '千葉県安房郡鋸南町・元名海岸に佇む、2026年6月にオープンした酒宿です。文化や自然に触れる「酒旅」をご提案しています。',
                jobs: [
                    {
                        offerId: '121099',
                        badgeLabel: '料飲部門 | 料飲全般',
                        title: '《サービススタッフ｜南房総》社宅・寮あり＊賞与年2回＊最高のロケーション✨',
                        brandName: '紀伊乃国屋グループ いっぺ THE SAKE RYOKAN',
                        brandLogo:
                            '/features/kinokuniya-20260727/logo_kinokuniya.png',
                        salary: '350~420',
                        salaryUnit: '年収',
                        prefecture: '千葉県',
                        city: '安房郡鋸南町',
                        image: '/features/kinokuniya-20260727/job_card_ippe_01.jpg',
                        href: 'https://hotel.foods-labo.com/offers/121099',
                        analyticsLabel: 'CT_Jobinformation_求人例-いっぺ-1st',
                    },
                    {
                        offerId: '121098',
                        badgeLabel: '宿泊部門 | 宿泊全般',
                        title: '【南房総＊夜勤なし＊寮・家賃補助あり】日本建築ならではの趣×現代的な快適さ',
                        brandName: '紀伊乃国屋グループ いっぺ THE SAKE RYOKAN',
                        brandLogo:
                            '/features/kinokuniya-20260727/logo_kinokuniya.png',
                        salary: '350~420',
                        salaryUnit: '年収',
                        prefecture: '千葉県',
                        city: '安房郡鋸南町',
                        image: '/features/kinokuniya-20260727/job_card_ippe_02.jpg',
                        href: 'https://hotel.foods-labo.com/offers/121098',
                        analyticsLabel: 'CT_Jobinformation_求人例-いっぺ-2nd',
                    },
                ],
            },
            {
                id: 'yuumi',
                categoryLabel: 'ゆうみ',
                variant: 'list',
                description:
                    '全室オーシャンビューのビーチサイド温泉リゾートです。南房総・鋸南の天然温泉、旬食材を使った料理で、心が落ち着く滞在を提供しています。',
                jobs: [
                    {
                        offerId: '114530',
                        badgeLabel: '料飲部門 | 料飲全般',
                        title: '【リゾートの料飲・宿泊サービス】寮・家賃補助あり＊母体超安定＊賞与年2回',
                        brandName: '紀伊乃国屋グループ ゆうみ',
                        brandLogo:
                            '/features/kinokuniya-20260727/logo_kinokuniya.png',
                        salary: '350~420',
                        salaryUnit: '年収',
                        prefecture: '千葉県',
                        city: '安房郡鋸南町',
                        image: '/features/kinokuniya-20260727/job_card_yuumi_01.jpg',
                        href: 'https://hotel.foods-labo.com/offers/114530',
                        analyticsLabel: 'CT_Jobinformation_求人例-ゆうみ-1st',
                    },
                    {
                        offerId: '109798',
                        badgeLabel: '宿泊部門 | 宿泊全般',
                        title: '《寮・家賃補助＊最高のロケーション✨》南房総のホテルサービスを募集｜夜勤無',
                        brandName: '紀伊乃国屋グループ ゆうみ',
                        brandLogo:
                            '/features/kinokuniya-20260727/logo_kinokuniya.png',
                        salary: '350~420',
                        salaryUnit: '年収',
                        prefecture: '千葉県',
                        city: '安房郡鋸南町',
                        image: '/features/kinokuniya-20260727/job_card_yuumi_02.jpg',
                        href: 'https://hotel.foods-labo.com/offers/109798',
                        analyticsLabel: 'CT_Jobinformation_求人例-ゆうみ-2nd',
                    },
                ],
            },
        ],
    },
}
